<template>
  <update-card
    :tabs="tabs"
    :id="id"
    storeNamespace="settings"
    objectNamespace="O_site"
    @visitedTabs="visitedTabs"
  >

  </update-card>
</template>

<script>
/* eslint-disable vue/no-unused-components */
import UpdateCard from '@/components/card/UpdateCard'
import Queues from '../components/Queues'
import SiteExpansionUpdate from '../components/SiteExpansionUpdate'

export default {
    components: {
        UpdateCard,
    },
    props: {
        id: {
            type: String
        },
    },
    data() {
        return {
            tabsVisited: []
        }
    },
    computed: {
        tabs() {
            return [
                {
                    name: 'Grunduppgifter', 
                    icon: 'mdi-tray-full',
                    component: SiteExpansionUpdate,
                    props: {
                        id: this.id,
                        initialLoad: this.tabsVisited.includes(0) ? true : false
                    }
                },
                {
                    name: 'Köer', 
                    icon: 'mdi-tray-full',
                    component: Queues
                }
            ]
        }
    },
    methods: {
        visitedTabs(value) {
            this.tabsVisited = value
        }
    },
}
</script>

<style>

</style>